export type EulerOrder = "XYZ" | "YXZ"
export const DefaultEuler = "XYZ";